export class DataCatalogJoinabilityEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "source",
            "baseName": "source",
            "type": "DataCatalogJoinabilitySide",
            "format": ""
        },
        {
            "name": "target",
            "baseName": "target",
            "type": "DataCatalogJoinabilitySide",
            "format": ""
        },
        {
            "name": "detectedBy",
            "baseName": "detectedBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "confidence",
            "baseName": "confidence",
            "type": "number",
            "format": "double"
        },
        {
            "name": "sharedValues",
            "baseName": "sharedValues",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "leftDistinct",
            "baseName": "leftDistinct",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rightDistinct",
            "baseName": "rightDistinct",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogJoinabilityEntry.attributeTypeMap;
    }
    constructor() {
    }
}
